import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { IconChooser, Colours, MessagePropType } from '@ratehub/base-ui';


function HeroTabContentListItem({
    index,
    iconKey,
    title,
    subtitle,
    href,
}) {
    return (
        <Container className="rh-height-100p rh-display-flex rh-flex-direction-column rh-justify-content-center">
            <a
                href={href}
                className="rh-display-flex rh-align-items-center rh-justify-content-space-between rh-py-1 rh-text-decoration-none"
                data-name={`hero-tab-content-list-item-link-${index}`}
            >
                <div className="rh-width-100p rh-display-flex rh-align-items-center rh-justify-content-space-between rh-gap-1">
                    <IconChooser
                        iconKey={iconKey}
                        size="XL"
                        outlineWidth="0"
                        fillColour={Colours.BLUEBERRY_LIGHTEST}
                        stroke={Colours.BLUEBERRY_DARK}
                    />
                    <div className="rh-width-100p">
                        <span className="rh-display-flex rh-align-items-flex-start rh-justify-content-space-between rh-gap-1">
                            <h3 className="rh-fg-blueberry-dark weight-medium rh-m-0">
                                {title}
                            </h3>
                            <IconChooser
                                iconKey="arrow-right"
                                size="M"
                                outlineWidth="0"
                                fillColour={Colours.TRANSPARENT}
                                stroke={Colours.BLUEBERRY_DARK}
                            />
                        </span>
                        <p className="weight-medium rh-m-0">
                            {subtitle}
                        </p>
                    </div>
                </div>
            </a>
        </Container>
    );
}

HeroTabContentListItem.propTypes = {
    index: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
    iconKey: PropTypes.string.isRequired,
    title: MessagePropType.isRequired,
    subtitle: MessagePropType.isRequired,
    href: PropTypes.string.isRequired,
};

const Container = styled.li`
    transition: background-color 0.3s ease;
    &:hover {
        background-color: ${Colours.BLUEBERRY_LIGHTEST};
    }

    > a {
        color: inherit;
    }

    &:not(:last-child) {
        border-bottom: 2px dotted ${Colours.STONE};
    }
`;

export default HeroTabContentListItem;
